// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout padrão (sem alto contraste) */
.full-screen-div {
  background-color: white;
}

/* Footer padrão (sem alto contraste) */
.footer.bg-light {
  background: linear-gradient(0deg, rgba(223, 226, 223, 1) 0%, rgba(255, 255, 255, 100) 100%) !important;
}

/* Override quando estiver em alto contraste - já definido em HighContrast.css */
`, "",{"version":3,"sources":["webpack://./src/service/components/css/Layout.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC;EACE,sGAAsG;AACxG;;AAEA,gFAAgF","sourcesContent":["/* Layout padrão (sem alto contraste) */\n.full-screen-div {\n  background-color: white;\n}\n\n/* Footer padrão (sem alto contraste) */\n.footer.bg-light {\n  background: linear-gradient(0deg, rgba(223, 226, 223, 1) 0%, rgba(255, 255, 255, 100) 100%) !important;\n}\n\n/* Override quando estiver em alto contraste - já definido em HighContrast.css */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
